import axios, { type AxiosInstance, type CreateAxiosDefaults } from 'axios'

import { env } from '@/env'
import { stringifyQueryParams } from '@/shared/lib/url/query-params'

export type ApiClientConfig = CreateAxiosDefaults & {
  baseURL: string
}

export function createApiClient(config: ApiClientConfig): AxiosInstance {
  return axios.create({
    ...config,
    paramsSerializer: {
      serialize: params => stringifyQueryParams(params)
    }
  })
}

export const selfApi = createApiClient({
  baseURL: '/api',
  headers: { accept: 'application/json' }
})

export const publicApi = createApiClient({
  baseURL: env.NEXT_PUBLIC_EVNTTZ_BACKEND_API_BASE_URL,
  headers: {
    accept: 'application/json',
    Authorization: `Bearer ${env.NEXT_PUBLIC_EVNTTZ_API_AUTH_TOKEN}`
  }
})

export const publicApiWithoutAuth = createApiClient({
  baseURL: env.NEXT_PUBLIC_EVNTTZ_BACKEND_API_BASE_URL,
  headers: { accept: 'application/json' }
})
